<template>
  <div>
    <div class="wrapper face-b" v-if="isWeixin"></div>
    <div v-else class="wrapper face-a">
      <div style="height: 118px"></div> 
      <p class="slogan">
      <br />
       <br />
        <br />
         <br />
          <br />
           <br />
      </p>
      <button class="download-btn" @click="downloadPackage">
        <span>免费下载</span>
        <img src="../assets/download.svg" alt="" class="download-logo" />
      </button>
    </div>
  </div>
</template>

<script>
import { service } from "../utils/request";
import { Dialog } from "vant";
export default {
  data() {
    return {
      isIOS: window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isWeixin:
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1,
    };
  },
  methods: {
    async downloadPackage() {
      let downloadUrl = "";
      const res = await service.get(
        "/app/version/new/url/get?appType=" + (this.isIOS ? 2 : 1)
      );
      if (res.data.code === "00000") {
        downloadUrl = res.data.data;
        if (downloadUrl) {
          window.location.href = downloadUrl;
        } else {
          Dialog({ message: "下载地址不存在" });
        }
      } else {
        Dialog({ message: "网络错误，请重试" });
      }
    },
  },
  mounted() {
    window.document.title = "文冠优品";
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

div,
button,
h1,
p {
  margin: 0;
  box-sizing: border-box;
}

button {
  border: none;
  outline: none;
}

h1 {
  font-weight: normal;
}

.wrapper {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  padding-bottom: 30px;
}

.face-a {
  background: linear-gradient(180deg, #FF7A45 0%, #FF5A1F 100%);
  padding-top: 35px;
  text-align: center;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.face-a::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.2) 2px, transparent 2px);
  background-size: 30px 30px;
  z-index: 0;
}

.face-b {
  background-image: url("../assets/back2.jpg");
}

.top-logo {
  width: 55px;
  padding-bottom: 40px;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.mid-logo {
  height: 95px;
  display: block;
  margin: 0 auto;
}

.slogan {
  padding: 10px;
  line-height: 1.5;
  font-size: 18px;
}

.download-btn {
  color: #fff;
  width: 180px;
  height: 52px;
  line-height: 52px;
  font-size: 18px;
  background: linear-gradient(135deg, #FF7A45 0%, #FF5A1F 100%);
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 100px;
  box-shadow: 0 4px 16px rgba(255, 90, 31, 0.4);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 90, 31, 0.5);
}

.download-btn:active {
  transform: translateY(0);
}

.download-logo {
  width: 20px;
  padding-left: 0.5em;
  transform: translateY(-2px);
}
</style>
